import Vue from 'vue'
import { Lazyload } from 'vant'
// import '@/styles/var.less'
import '@/styles/index.css'
import '@/styles/mystyle.css'
import App from './App.vue'
import store from './store'
import router from './router'
import './assets/iconfont/iconfont.css'
import { getUrlKey } from '@/utils/base'
import commondata from '@/commondata.js'
import { Row, Col, Cell, CellGroup } from 'vant'
import globalVariable from '@/api/global_variable.js'
import { CheckSystemType } from '@/utils/request'
import BaiduMap from 'vue-baidu-map'
import VueWechatTitle from 'vue-wechat-title'
import echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(Row).use(Col).use(Cell).use(CellGroup).use(Lazyload).use(VueWechatTitle).use(VueClipboard).use(VueAwesomeSwiper)
  .use(BaiduMap, {
    ak: 'DEv4xkthxwvWef7TpxmaFe5Uadc6Povr'
  })

router.beforeEach((to, from, next) => {
  var urlSystem = getUrlKey('system')
  if (urlSystem) {
    commondata.systemBase = urlSystem
    // console.log('现在的系统切换为:' + urlSystem)
  }
  if (!urlSystem) {
    if (CheckSystemType('ssi')) {
      commondata.systemBase = 'store'
    }
  }
  // console.log('to:', to)
  // console.log('from:', from)
  if (to.fullPath.indexOf('system=') < 0 && commondata.systemBase) {
    // console.log('system参数没找到', urlSystem)
    if (to.fullPath.indexOf('?') > 0) {
      next(to.fullPath + '&system=' + commondata.systemBase + '&t=' + Date.now())
    } else {
      next(to.fullPath + '?system=' + commondata.systemBase + '&t=' + Date.now())
    }
  } else {
    // console.log('system参数找到了', urlSystem)
  }
  // var system = window.location.host.split('.')[0]
  // console.log('systemCode:', system)
  // if (system !== 'm') {
  //   var newUrl = window.location.href.replace('://' + system, '://m')
  //   window.location.href = newUrl
  //   next(false)
  // }
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.afterEach((to, from) => {
  if (!globalVariable.IosStartURL) {
    globalVariable.IosStartURL = to.fullPath.split('#')[0]
    console.log('IosStartURL存储', globalVariable.IosStartURL)
  }
  console.log('IosStartURL最终', globalVariable.IosStartURL)
  // console.log('router.afterEach')
  // console.log('from', to)
  // console.log('to', to)
  // console.log('url', to.fullPath)
  // console.log('IosStartURL', globalVariable.IosStartURL)
})
